// extracted by mini-css-extract-plugin
export var statItem = "_dr-1";
export var statsRow = "_dr-0";